import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import EstadoFisico from './EstadoFisico';




interface EstadoFisicoTableProps {
  data: EstadoFisico[];
  columns: TableColumn<EstadoFisico>[];
  customStyles: Record<string, any>;
}

const EstadoDetramiteTable: React.FC<EstadoFisicoTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<EstadoFisico>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default EstadoDetramiteTable;